import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const examinationApi = createApi({
  reducerPath: "examinations",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["Examination", "ExaminationDetail"],
  endpoints: (builder) => ({
    startExamination: builder.mutation({
      query: (data) => apiFunction(data, "/api/clinic/examinations/start", "POST"),
      invalidatesTags: ["Examination"],
    }),

    // Randevunun muayenesini yalnız okur (başlatmaz); yoksa 404.
    getExaminationByAppointment: builder.query({
      query: ({ token, appointmentId }) => ({
        url: `/api/clinic/examinations/by-appointment/${appointmentId}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }),
      // Oturum sayfası bunu lazy çağırıp unwrap() ediyor. keepUnusedDataFor 0
      // iken StrictMode'un mount→unmount'u kaydı yanıt gelmeden siliyor,
      // unwrap() undefined dönüyor ve muayene "yok" sanılıyordu.
      keepUnusedDataFor: 60,
    }),

    getExaminationDetail: builder.query({
      query: ({ token, id }) => ({
        url: `/api/clinic/examinations/${id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      }),
      providesTags: (_result, _err, arg) => [
        { type: "ExaminationDetail", id: arg.id },
      ],
    }),

    completeExamination: builder.mutation({
      query: ({ token, id }) =>
        apiFunction({ token }, `/api/clinic/examinations/${id}/complete`, "POST"),
      invalidatesTags: (_res, _err, arg) => [
        "Examination",
        { type: "ExaminationDetail", id: arg.id },
      ],
    }),

    cancelExamination: builder.mutation({
      query: ({ token, id, reason }) =>
        apiFunction({ token, reason }, `/api/clinic/examinations/${id}/cancel`, "POST"),
      invalidatesTags: (_res, _err, arg) => [
        "Examination",
        { type: "ExaminationDetail", id: arg.id },
      ],
    }),
  }),
});

export const {
  useStartExaminationMutation,
  useGetExaminationByAppointmentQuery,
  useLazyGetExaminationByAppointmentQuery,
  useGetExaminationDetailQuery,
  useLazyGetExaminationDetailQuery,
  useCompleteExaminationMutation,
  useCancelExaminationMutation,
} = examinationApi;
